// -------------------------------------
// Provide array of keys for questions
// -------------------------------------
export function questions( { drugs, rules, faqs } ) {

  // Create array with rules alter
  const list = Object.values( rules ).filter( r => r.group == "kinetic" )

  // Nothing to do here
  if ( !list.length ) return []

  // Check rules for questions and don't add twice
  const missing = {}

  // "auc_factor": {
  //   "cyp2d6": false
  // }
  for ( const item of list ) {
    if ( item.predict && item.predict.auc_factor ) {
      Object.keys( item.predict.auc_factor ).forEach( factor => {
        // For the moment keep only cyps
        if ( /cyp/i.test( factor ) == false ) return

        if ( item.predict.auc_factor[ factor ] == false ) {
          missing[ factor ] = true
        }
      } );
    }
  }

  return Object.keys( missing )
}